import Link from "next/link";


import { externalLinks } from "@/data/links/external-links";
import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

export const Disclaimer = ({ lang }: { lang: Lang }) => {
  const { t } = getTranslations(lang);

  return (
    <p className="flex w-full flex-wrap items-center justify-end">
      <span className="text-xs text-zinc-500">
        {t.winwingpt.riskDisclosure}
      </span>{" "}
      <Link
        href={externalLinks.riskDisclosureStatement({ lang })}
        className="text-xs font-medium text-sky-500"
      >
        {t.winwingpt.disclaimer}
      </Link>
    </p>
  );
};
